import React from "react"
import Navbar from "../../Common/Navbar"
import Footer from "../../Common/Footer"
import Sidebar from "../../Sidebar/Sidebar"
import BulletinComp from "./Component/BulletinComp"



const Bulletin = () => {
    return (
        <>
            <Navbar />
            <div className="d-flex mainContentArea">
                <Sidebar />
                <BulletinComp />
            </div>
            <Footer />
        </>
    )
}

export default Bulletin;